/*
  DON'T import this file directly, import src/graphql/index.js into your deps
  When you need to modify a query or fragment, modify the .graphql files - NOT the __generated__ files
  Each time you modify a GraphQL file, the node_modules/.cache/babel-loader folder must be cleared for the changes to take effect
*/

import { type GraphQLRequestParams } from '../types';

import { Templates } from './__generated__';

interface IQueryRequestVariables {
  // TODO WEBCA-1926: Remove this option and its references after curator project launches
  withCollaborations?: boolean;
}

interface IQueryRequestVariableGetDetails extends IQueryRequestVariables {
  pandoraId: string;
}

interface IQueryRequestVariableGetAnnotations extends IQueryRequestVariables {
  pandoraIds: string[];
}

const getArtistDetails = (
  requestVariables: IQueryRequestVariableGetDetails,
): GraphQLRequestParams<IQueryRequestVariableGetDetails> => {
  const { pandoraId, withCollaborations } = requestVariables;

  return {
    query: withCollaborations
      ? Templates.GetArtistDetailsWithCollaborations
      : Templates.GetArtistDetails,
    operationKeyName: withCollaborations
      ? 'GET_ARTIST_DETAILS_WITH_COLLABORATIONS'
      : 'GET_ARTIST_DETAILS',
    variables: { pandoraId },
  };
};

const getArtistCollaborations = (
  requestVariables: IQueryRequestVariableGetDetails,
): GraphQLRequestParams<IQueryRequestVariableGetDetails> => {
  const { pandoraId } = requestVariables;
  return {
    query: Templates.GetArtistCollaborations,
    operationKeyName: 'GET_ARTIST_COLLABORATIONS',
    variables: { pandoraId },
  };
};

const getComposerDetails = (
  requestVariables: IQueryRequestVariableGetDetails,
): GraphQLRequestParams<IQueryRequestVariableGetDetails> => {
  const { pandoraId } = requestVariables;
  return {
    query: Templates.GetComposerDetails,
    operationKeyName: 'GET_COMPOSER_DETAILS',
    variables: { pandoraId },
  };
};

const getStationCurators = (
  requestVariables: IQueryRequestVariableGetAnnotations,
): GraphQLRequestParams<IQueryRequestVariableGetAnnotations> => {
  const { pandoraIds } = requestVariables;
  return {
    query: Templates.GetStationCurators,
    operationKeyName: 'GET_STATION_CURATORS',
    variables: { pandoraIds },
  };
};

const getPlaylistCurators = (
  requestVariables: IQueryRequestVariableGetAnnotations,
): GraphQLRequestParams<IQueryRequestVariableGetAnnotations> => {
  const { pandoraIds } = requestVariables;
  return {
    query: Templates.GetPlaylistCurators,
    operationKeyName: 'GET_PLAYLIST_CURATORS',
    variables: { pandoraIds },
  };
};

export default {
  getArtistDetails,
  getArtistCollaborations,
  getComposerDetails,
  getStationCurators,
  getPlaylistCurators,
  // deprecated WEBCA-2418 - the exports below are for queries that use the deprecated UrqlClient.
  // Instead of exporting templates, please use the pattern above of creating a requestParams functions.
  getPlaylistCurator: Templates.GetPlaylistCurator,
  getCuratorDetails: Templates.GetCuratorDetails,
  getRecentlyPlayedSources: Templates.GetRecentlyPlayedSources,
  getAlbumDetails: Templates.GetAlbumDetails,
  getArtistDetailsWithCurators: Templates.GetArtistDetailsWithCurators,
  getStationCurator: Templates.GetStationCurator,
};
